import React, { useEffect, useState } from 'react'
import api from '../api'
import { Images } from 'lucide-react'
import { Card, PageHeader, Input, Button, Modal, EmptyState } from '../components/ui'

export default function FotoGallery() {
  const [fotos, setFotos] = useState([])
  const [loading, setLoading] = useState(false)
  const [preview, setPreview] = useState(null)
  const [bulan, setBulan] = useState(() => {
    const now = new Date()
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`
  })

  useEffect(() => { load() }, [bulan])

  async function load() {
    setLoading(true)
    try {
      const res = await api.get(`/foto?bulan=${bulan}`)
      setFotos(res.data)
    } finally { setLoading(false) }
  }

  return (
    <div>
      <PageHeader
        title="Bukti Foto"
        subtitle={`${fotos.length} foto ditemukan`}
        actions={<Input type="month" value={bulan} onChange={e => setBulan(e.target.value)} style={{ width: 160 }} />}
      />

      {loading ? (
        <div style={{ textAlign: 'center', padding: 60, color: 'var(--text-faint)' }}>Memuat foto...</div>
      ) : fotos.length === 0 ? (
        <EmptyState icon={Images} title="Belum ada foto untuk periode ini" />
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 16 }}>
          {fotos.map(f => {
            const [bulanFolder, namaFile] = f.filepath.split('/')
            const url = `/api/foto/file/${bulanFolder}/${namaFile}`
            return (
              <Card key={f.id} style={{ overflow: 'hidden', cursor: 'pointer' }} onClick={() => setPreview({ ...f, url })}>
                <img src={url} alt="bukti"
                  style={{ width: '100%', height: 160, objectFit: 'cover', display: 'block' }}
                  onError={e => { e.target.style.display = 'none' }} />
                <div style={{ padding: '11px 13px' }}>
                  <div style={{ fontWeight: 600, fontSize: 13 }}>{f.teknisi_nama || '-'}</div>
                  <div style={{ fontSize: 11.5, color: 'var(--text-muted)', marginTop: 2 }}>{f.tanggal} · {f.jenis_pekerjaan_kode}</div>
                  <div style={{ fontSize: 11.5, color: 'var(--text-faint)', marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{f.lokasi}</div>
                </div>
              </Card>
            )
          })}
        </div>
      )}

      {/* Preview modal */}
      {preview && (
        <Modal onClose={() => setPreview(null)} width={600}>
          <div style={{ margin: -28, marginBottom: 0 }}>
            <img src={preview.url} alt="preview"
              style={{ width: '100%', maxHeight: 420, objectFit: 'contain', background: '#0b0b16', borderRadius: '16px 16px 0 0', display: 'block' }} />
          </div>
          <div style={{ paddingTop: 18 }}>
            <div style={{ fontWeight: 600, fontSize: 14 }}>{preview.teknisi_nama || '-'}</div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 4 }}>
              {preview.tanggal} · {preview.jenis_pekerjaan_kode} · {preview.lokasi}
            </div>
            <Button variant="neutral" onClick={() => setPreview(null)} style={{ marginTop: 14 }}>Tutup</Button>
          </div>
        </Modal>
      )}
    </div>
  )
}
